<template>
  <v-dialog
    v-model="dialog"
    width="290"
  >
    <template v-slot:activator="{ on }">
      <div v-on="on" class="j-date-field">
        <slot>
          <v-text-field
            :value="value"
            @change="change"
            :label="label"
            :clearable="true"
            append-icon="mdi-calendar"
            readonly
            :hint="hint"
            :persistent-hint="persistentHint"
            :hide-details="hideDetails"
            class="pointer"
          ></v-text-field>
        </slot>
      </div>
    </template>

    <v-card>
      <j-date-picker
        :value="value"
        :allowed-dates="allowedDates || (() => [])"
        @change="change"
        @close="dialog = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import JDatePicker from '@/ui/controls/JDatePicker'

export default {
  components: {
    JDatePicker,
  },
  props: {
    value: undefined,
    label: {
      type: String,
      default: "Date",
    },
    allowedDates: {
      type: Function,
      default: () => [],
    },
    hideDetails: Boolean,
    persistentHint: Boolean,
    hint: String,
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    change(e) {
      console.log('JDateField.change()', e)
      this.$emit('input', e)
      this.$emit('change', e)
      this.$emit('update:value', e)
    },
  },
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>